import { Card } from "../components";
import { useTitle } from "../hooks/useTitle";

export const MovieList = ({ movies, filter, title }) => {
  useTitle(title);

  let filteredMovies = movies;

  if (filter === "popular") {
    filteredMovies = [...movies].sort((a, b) => b.vote_count - a.vote_count);
  } else if (filter === "top") {
    filteredMovies = [...movies].sort((a, b) => b.vote_average - a.vote_average);
  } else if (filter === "upcoming") {
    filteredMovies = [...movies].sort(
      (a, b) => new Date(a.release_date) - new Date(b.release_date)
    );
  }

  return (
    <main>
      <section className="max-w-7xl mx-auto py-7 flex flex-wrap justify-start">
        {filteredMovies.map((movie) => (
          <Card key={movie.id} movie={movie} />
        ))}
      </section>
    </main>
  );
};
